import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const DrugListForm = (props) => {

    const initialFormData = {
        drug: '',
        strength: '',
        strengthvalue: '',
        ndc: '',
        generic: '',
        brand_drug: '',
        caution1: '',
        caution2: '',
        caution3: '',
        drug_form: ''
    };
    const data = props.druglistvalue;
    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        if (props.edittrigger > 0) {
            populateData();
        }
    }, [props.edittrigger]);

    async function populateData() {
        formRef.current.reset();
        let value = data;
        setFormData({
            drug_id: value.drug_id,
            drug: value.drug,
            strength: value.strength,
            strengthvalue: value.strengthValue,
            ndc: value.ndc,
            generic: value.generic,
            brand_drug: value.brand_drug,
            caution1: value.caution1,
            caution2: value.caution2,
            caution3: value.caution3,
            drug_form: value.drug_form
        })
        setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
    }

    const handleSubmit = async e => {
        e.preventDefault();

        const newErrors = {};
        if (!formData.drug.trim()) newErrors.drug = 'Drug is required';
        if (!formData.ndc.trim()) newErrors.ndc = 'NDC is required';
        if (!formData.strengthvalue.trim()) newErrors.strengthvalue = 'Strength Value is required';
        if (!formData.strength.trim()) newErrors.strength = 'Strength is required';
        if (!formData.drug_form.trim()) newErrors.drug_form = 'Drug Form is required';

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsDrugsUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/drugs/add-drug" :
            `${process.env.REACT_APP_SERVER_URL}` + "/drugs/update-drug";

        let pelmedsDrugsData = buttonStatus == "Add" ?
            {
                "drug": formData.drug,
                "strength": formData.strength,
                "strength_value": formData.strengthvalue,
                "NDC": formData.ndc,
                "generic": formData.generic,
                "brand": formData.brand_drug,
                "caution_1": formData.caution1,
                "caution_2": formData.caution2,
                "caution_3": formData.caution3,
                "drug_form": formData.drug_form
            } :
            {
                "id": formData.drug_id,
                "drug": formData.drug,
                "strength": formData.strength,
                "strength_value": formData.strengthvalue,
                "NDC": formData.ndc,
                "generic": formData.generic,
                "brand": formData.brand_drug,
                "caution_1": formData.caution1,
                "caution_2": formData.caution2,
                "caution_3": formData.caution3,
                "drug_form": formData.drug_form
            }

        //console.log("pelmedsDrugsData" + JSON.stringify(pelmedsDrugsData));

        const { data } = await axios.post(pelmedsDrugsUrl, pelmedsDrugsData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Drugs List added/updated successfully");
            setFormData(initialFormData);
            formRef.current.reset();
            setButtonStatus("Add");
    
            props.onCallParent();
        }
        else {
            toast.info("Error while adding Drugs List");
        }

    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Drug</Form.Label>
                        <Form.Control
                            placeholder='Drug'
                            value={formData.drug}
                            name="drug"
                            onChange={handleFieldChange}
                            type="text"
                            isInvalid={!!errors.drug}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.drug}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Ndc</Form.Label>
                        <Form.Control
                            placeholder='Ndc'
                            value={formData.ndc}
                            name="ndc"
                            onChange={handleFieldChange}
                            type="text"
                            isInvalid={!!errors.ndc}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.ndc}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className='required'>Strength Value</Form.Label>
                        <Form.Control
                            placeholder='Strength Value'
                            value={formData.strengthvalue}
                            name="strengthvalue"
                            onChange={handleFieldChange}
                            type="text"
                            isInvalid={!!errors.strengthvalue}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.strengthvalue}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className='required'>Strength</Form.Label>
                        <Form.Control
                            placeholder='Strength'
                            value={formData.strength}
                            name="strength"
                            onChange={handleFieldChange}
                            type="text"
                            isInvalid={!!errors.strength}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.strength}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className='required'>Drug Form</Form.Label>
                        <Form.Control
                            placeholder='Drug Form'
                            value={formData.drug_form}
                            name="drug_form"
                            onChange={handleFieldChange}
                            type="text"
                            isInvalid={!!errors.drug_form}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.drug_form}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Generic</Form.Label>
                        <Form.Control
                            placeholder='Generic'
                            value={formData.generic}
                            name="generic"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Brand</Form.Label>
                        <Form.Control
                            placeholder='Brand'
                            value={formData.brand_drug}
                            name="brand_drug"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Caution 1</Form.Label>
                        <Form.Control
                            placeholder='Caution 1'
                            value={formData.caution1}
                            name="caution1"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Caution 2</Form.Label>
                        <Form.Control
                            placeholder='Caution 2'
                            value={formData.caution2}
                            name="caution2"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Caution 3</Form.Label>
                        <Form.Control
                            placeholder='Caution 3'
                            value={formData.caution3}
                            name="caution3"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            // disabled={!formData.pharmacy}
                            >
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
};
export default DrugListForm;
